import { render, staticRenderFns } from "./CreateEditorial.vue?vue&type=template&id=78608057&scoped=true&"
import script from "./CreateEditorial.vue?vue&type=script&lang=js&"
export * from "./CreateEditorial.vue?vue&type=script&lang=js&"
import style0 from "./CreateEditorial.vue?vue&type=style&index=0&id=78608057&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78608057",
  null
  
)

export default component.exports